import { render, staticRenderFns } from "./x-ShengLiShuiKuBengQianKanBan.vue?vue&type=template&id=1ffb7036&scoped=true"
import script from "./x-ShengLiShuiKuBengQianKanBan.vue?vue&type=script&lang=js"
export * from "./x-ShengLiShuiKuBengQianKanBan.vue?vue&type=script&lang=js"
import style0 from "./x-ShengLiShuiKuBengQianKanBan.vue?vue&type=style&index=0&id=1ffb7036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb7036",
  null
  
)

export default component.exports